
import React, { useState, useEffect } from 'react';
import { Copy, Check } from 'lucide-react';
import styles from './LogModal.module.css';

interface LogModalProps {
    open: boolean;
    onClose: () => void;
    log: {
        id: number;
        message: string;
        level: string;
        source?: string;
        context?: string;
        timestamp: string | Date;
        user_id?: string | null;
        user_email?: string | null;
    } | null;
}

const LogModal: React.FC<LogModalProps> = ({ open, onClose, log }) => {
    const [copied, setCopied] = useState(false);
    
    useEffect(() => {
        // Reset copied state when modal closes or log changes
        if (!open || !log) {
            setCopied(false);
        }
    }, [open, log]);
    
    if (!open || !log) return null;
    
    const copyContext = () => {
        const contextText = log.context || '';
        if (contextText) {
            navigator.clipboard.writeText(contextText);
            setCopied(true);
            // Reset after 10 seconds
            setTimeout(() => {
                setCopied(false);
            }, 10000);
        }
    };
    
    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <p>Log Details</p>
                    <button className={styles.closeBtn} onClick={onClose}>&times;</button>
                </div>
                <div className={styles.scrollArea}>
                    <div className={styles.label}>Log ID:</div>
                    <div className={styles.value}>{log.id}</div>
                    <div className={styles.label}>Level:</div>
                    <div className={styles.value}>{log.level}</div>
                    <div className={styles.label}>Source:</div>
                    <div className={styles.value}>{log.source || '-'}</div>
                    <div className={styles.label}>User:</div>
                    <div className={styles.value}>{log.user_email || log.user_id || '-'}</div>
                    <div className={styles.label}>Timestamp:</div>
                    <div className={styles.value}>{new Date(log.timestamp).toLocaleString()}</div>
                    <div className={styles.label}>Message:</div>
                    <div className={styles.value}>{log.message}</div>
                    <div className={styles.labelRow}>
                        <div className={styles.label}>Context:</div>
                        {log.context && (
                            <button 
                                className={`${styles.copyBtn} ${copied ? styles.copied : ''}`} 
                                onClick={copyContext}
                                title={copied ? "Copied!" : "Copy context to clipboard"}
                            >
                                {copied ? <Check size={16} /> : <Copy size={16} />}
                            </button>
                        )}
                    </div>
                    <div className={styles.value}>{log.context || '-'}</div>
                </div>
            </div>
        </div>
    );
};

export default LogModal;
